module.exports = __webpack_public_path__ + "static/img/dashboard.28a2a850.svg";